import { FC, useState } from 'react';
import { useTranslation, useSession } from '@nextgen-web-framework/all';
import {
  ProjectionType,
  logObject,
  productApi,
  productDataTransformer,
  type IProduct,
  type ProductData,
} from '@commerce-product-webcomponents/sdk';
import { Logger } from '@nextgen-web-framework/core';
// eslint-disable-next-line unused-imports/no-unused-imports
import { CardType, ProductCardComponent, type ProductCardComponentPropsTypes } from '../Molecules';
import VariantCard from '../VariantCard/VariantCard';
import { getFulfillmentType } from '../../utils';
import { GCOProductCardPropsTypes } from './types/propsTypes';
import styles from './GCOProductCard.module.scss';

export const loggerInstance = Logger?.getInstance(logObject('GCOProductCard'));

const GCOProductCard = (Component: FC<ProductCardComponentPropsTypes>) => {
  const GCOProductComp = (props: GCOProductCardPropsTypes): JSX.Element => {
    const t = useTranslation();
    const {
      brandName,
      productName,
      link,
      alt,
      productId,
      productSize,
      productPrice,
      currency,
      pointValue,
      businessVolume,
      className,
      variantGroupData,
      prefixText = t('product.common.item'),
      selectedVariantCb,
      productType,
      showZeroAsFree = true,
      showPreLaunch,
    } = props;

    const {
      session: { warehouseId = '' },
    } = useSession();

    const [product, setProduct] = useState({
      brandName: brandName,
      productName: productName,
      mainLink: link,
      productPrice: productPrice,
      currency: currency,
      alt: alt,
      productId: productId,
      productSize: productSize,
      pointValue: pointValue,
      businessVolume: businessVolume,
    } as IProduct);

    const dataRefreshHandler = (_productId: string) => {
      selectedVariantCb?.(_productId);
      productApi
        .getProductByIdOrError({
          productId: _productId,
          projections: ProjectionType.Detailed,
          warehouseId,
          fulfillmentType: getFulfillmentType(),
        })
        .then((productData: ProductData | Response) => {
          if (!(productData instanceof Response)) {
            const pd = productDataTransformer(productData, showPreLaunch);
            setProduct(pd);
          }
        })
        .catch((err: Error) => {
          loggerInstance?.error(err);
        });
    };

    return (
      <>
        <div className={styles['cpw-gco-card']}>
          <Component
            {...product}
            link={product.mainLink}
            cardType={CardType.GCOCARD}
            className={className}
            prefixText={prefixText}
            productType={productType}
            showZeroAsFree={showZeroAsFree}
          />
        </div>
        <VariantCard
          variantData={variantGroupData}
          defaultVariantItemId={productId}
          handleDataRefresh={(data) => dataRefreshHandler(data?.product?.items?.[0]?.itemNumber ?? '')}
        />
      </>
    );
  };
  return GCOProductComp;
};

export default GCOProductCard(ProductCardComponent);
export type { GCOProductCardPropsTypes };
